import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

type props = {
  title?: string
  children: React.ReactNode,
}

const FormSection = ({ title, children }: props) => {
  return (
    <S.FormSection key={title}>
      <>
        {title && <S.SectionHeader >{title}</S.SectionHeader>}
        { children }
      </>
    </S.FormSection>
  )
}

export default FormSection

const S = {
  FormSection: styled.div`
    & > div {
      margin: 10px 0 0 0;

      & label {
        font-weight: normal;
      }
    }
  `,
  SectionHeader: styled.h2`
    margin-top: 25px;
    border-bottom: solid 1px;
    border-color: ${color('border')};
    padding-bottom: 5px;
    text-transform: uppercase;
  `
}
